import DatePicker from '../components_v/v-date-picker'
import { DATE_PICKER_RANGE } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: DATE_PICKER_RANGE,
    mixins: [ commonMixins ],
    render(h) {
        const _this = this
        const {
             // eslint-disable-next-line 
             slots,scopedSlots,
             key,
             ...params 
            } = this.field
            params.locale = params.locale || "zh-cn"
            if (params.attach === undefined) {
                params.attach = true
            }
        let value = null
        if (Array.isArray(key)) {
            if (key.length !== 2 || key[0] === key[1]) {
                console.error('起始时间只能是两个不同的key')
            }
            value = key.map(item => _this.my_value[item]).filter(item => !!item)
        } else {
            if (!Array.isArray(key)) {
                _this.$set(_this.my_value, key, [null, null])
                value = _this.my_value[key] 
            } else {
                 value = _this.my_value[key] 
            }
        }
        return h(DatePicker, {
            slots: _this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
                ...params,
                value,
            },
            on: {
                changeDate(date) {
                    if (Array.isArray(key)) {
                        _this.my_value[key[0]] = date[0] || null
                        _this.my_value[key[1]] = date[1] || null
                      
                    } else {
                        _this.my_value[key] = date 
                    }
                },
            }
        })
    }
}